var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{attrs:{"dense":"","round":"","flat":"","icon":"mdi-refresh"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('Tooltip',[_vm._v("Refresh")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }